import { Component, computed, input } from '@angular/core';

import { Communication, CommunicationParticipantExtended } from '../../../services/dto/communication';
import { SwitchCases } from '../../../services/dto/switch-cases';
import { SwitchCasesAssigneeChangedComponent } from './templates/switch-cases-assignee-changed/switch-cases-assignee-changed.component';
import { SwitchCasesCriticityChangedComponent } from './templates/switch-cases-criticity-changed/switch-cases-criticity-changed.component';
import { SwitchCasesSubTaskCreatedComponent } from './templates/switch-cases-sub-task-created/switch-cases-sub-task-created.component';
import { SwitchCasesSubTypeChangedComponent } from './templates/switch-cases-sub-type-changed/switch-cases-sub-type-changed.component';
import { SwitchCasesTaskMergedComponent } from './templates/switch-cases-task-merged/switch-cases-task-merged.component';
import { SwitchCasesTaskStatusChangedComponent } from './templates/switch-cases-task-status-changed/switch-cases-task-status-changed.component';
import { SwitchCasesTeamChangedComponent } from './templates/switch-cases-team-changed/switch-cases-team-changed.component';
import { SwitchCasesToDoAddedComponent } from './templates/switch-cases-to-do-added/switch-cases-to-do-added.component';
import { SwitchCasesToDoClosedComponent } from './templates/switch-cases-to-do-closed/switch-cases-to-do-closed.component';
import { SwitchCasesTypeChangedComponent } from './templates/switch-cases-type-changed/switch-cases-type-changed.component';

@Component({
  selector: 'cam-communication-message-system',
  templateUrl: './message-system.component.html',
  styleUrls: ['./message-system.component.scss'],
  imports: [
    SwitchCasesTaskMergedComponent,
    SwitchCasesTypeChangedComponent,
    SwitchCasesSubTypeChangedComponent,
    SwitchCasesTaskStatusChangedComponent,
    SwitchCasesToDoAddedComponent,
    SwitchCasesToDoClosedComponent,
    SwitchCasesAssigneeChangedComponent,
    SwitchCasesSubTaskCreatedComponent,
    SwitchCasesCriticityChangedComponent,
    SwitchCasesTeamChangedComponent,
  ],
})
export class MessageSystemComponent {
  conversationParticipants = input.required<CommunicationParticipantExtended[]>();

  communication = input.required<Communication>();

  readonly body = computed<SwitchCases>(() => JSON.parse(this.communication().body));
}
